import React from 'react';
import '@lottiefiles/lottie-player';
import { create } from '@lottiefiles/lottie-interactivity';

class CarRotate extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef(); // 1. create a reference for the lottie player
  }
  componentDidMount() {
    // 3. listen for player load. see lottie player repo for other events
    this.myRef.current.addEventListener('load', function (e) {
      // 4. configure the interactivity library
      create({
        mode: 'cursor',
        player: '#thirdLottie',
        actions: [
          {
            position: { x: [0, 1], y: [-1, 2] },
            type: 'seek',
            loop: 'false',
            frames: [0, 40],
          },
          {
            position: { x: -1, y: -1 },
            type: "stop",
            frames: [0]
          }
        ],
      });
    });
  }
  render() {
    return (
      <div className="thirdLottie">
        <div style={{ height: '10px' }}></div>
        <lottie-player
          ref={this.myRef} // 2. set the reference for the player
          id="thirdLottie"
          renderer='canvas'
          mode="normal"
          src="https://assets5.lottiefiles.com/packages/lf20_l8phfwgq.json"
          style={{ width: '1500px' }}
        ></lottie-player>
      </div>
    );
  }
}

export default CarRotate;